interface FadeInSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}

const FadeInSection = ({ children, className = "" }: FadeInSectionProps) => {
  return (
    <div className={className}>
      {children}
    </div>
  );
};

export default FadeInSection;
